<mat-card appearance="outlined">
  <div class="card-header-container">
    <img class="accessory-box-img" [src]="'/files/profile/' + profile?.img" [alt]="profile?.name" defaultImg>
    <mat-card-header>
      <mat-card-title class="accessory-box-title">{{profile?.name}}
        @if (!isWysiwygEditorContentEmpty) {
          <button mat-icon-button color="secondary"
            (click)="clickShowInfoButton()" color="secondary">
            <mat-icon class="mat-18">info</mat-icon>
          </button>
        }
      </mat-card-title>
      <mat-card-subtitle class="accessory-box-description"></mat-card-subtitle>
    </mat-card-header>
  </div>
  <mat-card-content>
    <form [formGroup]="form">
      @if (canChangeProfileColor && (profile?.type === 'extension' || profile?.type === 'sandwich' || profile?.type === 'coupling' && showColorsWhenCoupling || showColorsInComplementary)) {
        <div
          >
          @if (profile?.selectedWood?.name) {
            <span>{{ 'WINDOW|Rodzaj drewna' | translate }}:
              <b>{{ profile?.selectedWood?.name }}</b>
              <br />
            </span>
          }
          @if ((profile?.selectedColor?.outer?.id === profile?.selectedColor?.inner?.id && profile?.selectedColor?.outer?.name)) {
            <span
              >
              {{ 'WINDOW|Kolor' | translate }}: <b>{{ profile?.selectedColor?.outer?.name }} @if (isWindowColor && !isDoor()) {
              ({{ 'WINDOW|Kolor konstrukcji' | translate
              }})
            }</b>
            <br />
          </span>
        }
        @if (profile?.selectedColor?.outer?.id !== profile?.selectedColor?.inner?.id) {
          @if (profile?.selectedColor?.outer?.name) {
            <span>
              {{ 'WINDOW|Kolor zewn.' | translate }}:
              @if (profile?.selectedColor?.outer?.name) {
                <b>
                  {{ profile?.selectedColor?.outer?.name }}
                  @if (isWindowColor && !isDoor()) {
                    ({{ 'WINDOW|Kolor konstrukcji' | translate
                    }})
                  }
                </b>
              }
              <br />
            </span>
          }
          @if (profile?.selectedColor?.inner?.name) {
            <span>
              {{ 'WINDOW|Kolor wewn.' | translate }}:
              @if (profile?.selectedColor?.inner?.name) {
                <b>
                  {{ profile?.selectedColor?.inner?.name }}
                  @if (isWindowColor && !isDoor()) {
                    ({{ 'WINDOW|Kolor konstrukcji' | translate
                    }})
                  }
                </b>
              }
              <br />
            </span>
          }
        }
        @if (!profile?.selectedColor?.outer?.isCore &&
          !profile?.selectedColor?.inner?.isCore &&
          profile?.selectedColor?.core?.name &&
          config().IccConfig.Configurators.showCoreColorInAdditionalProfilesAndAccessories
          ) {
          <span>{{ 'WINDOW|Kolor bazy' | translate }}:
            <b>{{ profile?.selectedColor?.core?.name }} @if (isWindowColor && !isDoor()) {
              ({{
              'WINDOW|Kolor konstrukcji' | translate }})
            }</b>
            <br />
          </span>
        }
        <div class="options-buttons">
          @if (anyColorButtonVisible) {
            <button mat-stroked-button color="primary"
            (click)="openModalColors()">{{ 'INTERFACE|Zmień' | translate }}</button>
          }
          @if (whiteColorButtonVisible) {
            <button mat-stroked-button color="primary"
            (click)="setWhiteColors()">{{ 'WINDOW|Biały' | translate }}</button>
          }
          @if (windowColorButtonVisible) {
            <button mat-stroked-button color="primary"
            (click)="setWindowColors()">{{ 'WINDOW|Kolor konstrukcji' | translate }}</button>
          }
          @if ((whiteColorButtonVisible || windowColorButtonVisible) && !noFreeExtensionColorSelection) {
            <div
              >
              <button class="button-dropdown-arrow" mat-stroked-button color="primary"
                [matMenuTriggerFor]="menu">
                <mat-icon>expand_more</mat-icon>
              </button>
              <mat-menu #menu="matMenu" xPosition="before" class="mat-menu-button-dropdown">
                <button mat-stroked-button color="primary" (click)="openModalColors()">
                  {{ 'INTERFACE|Zmień' | translate }}
                </button>
              </mat-menu>
            </div>
          }
        </div>
        @if (hasReinforcementsForProfile(profile)) {
          @if (config().IccConfig.Configurators.extensionsReinforcements && profile?.type === 'extension') {
            <span>
              {{ 'WINDOW|Wzmocnienie' | translate }}:
              @if (profile?.reinforcement?.name) {
                <b>{{ profile?.reinforcement?.name }}</b>
              }
              @if (!profile?.reinforcement?.name) {
                <b>{{ 'INTERFACE|Brak' | translate }}</b>
              }
              <br />
            </span>
          }
          <div class="options-buttons">
            @if (config().IccConfig.Configurators.extensionsReinforcements && profile?.type === 'extension') {
              <button mat-stroked-button color="primary"
                (click)="openModalReinforcements(profile)">{{ 'INTERFACE|Zmień' | translate }}</button>
            }
          </div>
        }
      </div>
    }

    @if (profile?.widthOutType && (
      profile?.type === 'coupling'
      || profile?.type === 'mullion'
      || profile?.type === 'fixed_mullion'
      || profile?.type === 'moveable_mullion'
      || profile?.type === 'frame'
    )) {
      <mat-form-field>
        <mat-label>{{ 'WINDOW|Szerokość' | translate }}</mat-label>
        <input
          matInput
          type="number"
          [min]="profile?.widthOutMin"
          [max]="profile?.widthOutMax"
          [(ngModel)]="profile.selectedWidth"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onSelectedWidthChange($event)">
        <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
      </mat-form-field>
      @if (profile?.widthOutMin || profile?.widthOutMax) {
        <div class="length-hint">
          {{ 'WINDOW|od {min} do {max} {unit}' | translate: {
            min: (profile?.widthOutMin | unitm:0:0:3),
            max: (profile?.widthOutMax | unitm:0:0:3),
            unit: dimensionUnit.unitSymbol
          } }}
        </div>
      }

      @if (profile?.couplingType === 'angle_coupling') {
        <mat-form-field>
          <mat-label>{{ 'WINDOW|Kąt' | translate }}</mat-label>
          <input
            matInput
            type="number"
            [min]="profile?.minAngle"
            [max]="profile?.maxAngle"
            [(ngModel)]="profile.angle"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onAngleChange($event)">
          <span matSuffix>°</span>
        </mat-form-field>
        <div class="length-hint">
          {{ 'WINDOW|od {min} do {max}' | translate: {
            min: (profile?.minAngle),
            max: (profile?.maxAngle),
          } }}
        </div>
      }
    }
    @if (profile?.type === 'coupling') {
            <button mat-icon-button
                    type="button"
                    class="width-info-button"
                    [matMenuTriggerFor]="widthInfoMenu"
                    (click)="$event.stopPropagation();">
              <mat-icon class="mat-18">info</mat-icon>
            </button>
          }
          <mat-menu #widthInfoMenu="matMenu" class="width-info-tooltip">
            @if (profile?.couplingType === 'rectangular_coupling') {
              <div class="width-info-content" (click)="$event.stopPropagation()">
                <img src="assets/lacznik_prostokatny.jpg" alt="Info" style="max-width: 300px;">
                <p style="margin:auto;">{{ 'WINDOW|Podaj Wymiar projektowany profilu' | translate }}</p>
              </div>
            }
            @if (profile?.couplingType === 'angle_coupling') {
              <div class="width-info-content" (click)="$event.stopPropagation()">
                <img src="assets/lacznik_katowy.jpg" alt="Info" style="max-width: 300px;">
                <p style="margin:auto;">{{ 'WINDOW|Podaj Wymiar projektowany profilu' | translate }}</p>
              </div>
            }
          </mat-menu>

    @if (optionsInComplementary) {
      <mat-form-field>
        <input matInput type="number" min="1" [placeholder]="'WINDOW|Ilość' | translate"
          formControlName="count">
        </mat-form-field>
      }
      @if (optionsInComplementary) {
        <mat-form-field>
          <input matInput iccDimensionInput type="number" min="0.01" step="0.01" formControlName="currentLength"
            [placeholder]="'WINDOW|Długość' | translate">
            <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
          </mat-form-field>
        }
        @if (profile?.type === 'sandwich') {
          <mat-form-field>
            <input matInput iccDimensionInput type="number" [placeholder]="'WINDOW|Wysokość' | translate"
              [min]="profile?.minHeight" [max]="profile?.maxHeight" formControlName="width">
              <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
            </mat-form-field>
          }
          @if (optionsInComplementary) {
            <mat-form-field>
              <input matInput type="text" formControlName="comment" [placeholder]="'INTERFACE|Komentarz' | translate">
            </mat-form-field>
          }
          @if (profile?.notStandardLength) {
            <div>
              <mat-checkbox (change)="toggleStandardLength($event)" [value]="true" [checked]="profile?.isDefaultLength">{{ 'WINDOW|Szerokość konstrukcji' | translate }}</mat-checkbox>
              @if (!profile?.isDefaultLength) {
                <mat-form-field>
                  <input matInput type="number" formControlName="length" [min]="profile?.minLength" [max]="profile?.maxLength" [step]="profile?.lengthStep" [placeholder]="'WINDOW|Długość' | translate" (change)="validateLength()">
                  <mat-hint class="length-hint" [ngClass]="{'invalid': invalidLength}">{{ 'WINDOW|Długość musi mieścić się w zakresie od {min} do {max} z dokładnością {step}' | translate: { min: profile?.minLength, max: profile?.maxLength, step: profile?.lengthStep } }}</mat-hint>
                </mat-form-field>
              }
            </div>
          }
          @if (!hiddenPrice) {
            <h4 class="item-price">{{ 'WINDOW|Cena profilu' | translate }}:
              <b>
                @if (hasZeroPrice(profile?.price, profile?.type)) {
                  <span>
                    {{ 'CONFIGURATOR|W cenie' | translate}}
                    <br>
                    </span>
                  }
                  @if (hasNoPrice(profile?.price, profile?.type)) {
                    <span>
                      {{ 'CONFIGURATOR|Do wyceny' | translate}}
                      <br>
                      </span>
                    }
                    @if (!hasZeroPrice(profile?.price, profile?.type) && ! hasNoPrice(profile?.price, profile?.type)) {
                      <span
                        >
                        @if (profile?.price.price_field && (!config().IccConfig.Configurators.price.frameProfilesAlt || profile?.type != 'frame')) {
                          <span
                            >
                            @if (profile.price.list_price_field && profile.price.list_price_field !== profile.price.price_field && listPriceEnable && listPriceEnableInMarket) {
                              <s
                                >
                                {{priceMarket(profile.price.list_price_field) | currency: currency}}
                              </s>
                            }
                            @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !profile.price.list_price_field) {
                              <span>
                                {{priceMarket(profile.price.price_field) | currency: currency}}/{{ 'WINDOW|pole' | translate }}
                              </span>
                            }
                            @if (listPriceEnable && !listPriceEnableInMarket && profile.price.list_price_field) {
                              <span>
                                {{priceMarket(profile.price.list_price_field) | currency: currency}}/{{ 'WINDOW|pole' | translate }}
                              </span>
                            }
                            <br>
                            </span>
                          }
                          @if (profile?.price.price_length && (!config().IccConfig.Configurators.price.frameProfilesAlt || profile?.type != 'frame')) {
                            <span
                              >
                              {{dimensionUnit.unitSymbol != 'mm' ? '~' : ''}}
                              @if (profile.price.list_price_length && profile.price.list_price_length !== profile.price.price_length && listPriceEnable && listPriceEnableInMarket) {
                                <s
                                  >
                                  {{priceMarket(profile.price.list_price_length) | unitm:0:0:3 | currency: currency}}
                                </s>
                              }
                              @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !profile.price.list_price_length) {
                                <span>
                                  {{priceMarket(profile.price.price_length) | unitm:0:0:3 | currency: currency}}/
                                </span>
                              }
                              @if (listPriceEnable && !listPriceEnableInMarket && profile.price.list_price_length) {
                                <span>
                                  {{priceMarket(profile.price.list_price_length) | unitm:0:0:3 | currency: currency}}/
                                </span>
                              }
                              <span [innerHTML]="2|formatUnit"></span>
                              <br>
                              </span>
                            }
                            @if (profile?.price.price_area) {
                              <span>
                                @if (profile.price.list_price_area && profile.price.list_price_area!== profile.price.price_area && listPriceEnable && listPriceEnableInMarket) {
                                  <s
                                    >
                                    {{priceMarket(profile.price.list_price_area) | currency: currency}}
                                  </s>
                                }
                                @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !profile.price.list_price_area) {
                                  <span>
                                    {{priceMarket(profile.price.price_area) | currency: currency}}/
                                  </span>
                                }
                                @if (listPriceEnable && !listPriceEnableInMarket && profile.price.list_price_area) {
                                  <span>
                                    {{priceMarket(profile.price.list_price_area) | currency: currency}}/
                                  </span>
                                }
                                <span [innerHTML]="1|formatUnit"></span>
                                <br>
                                </span>
                              }
                              @if (profile?.price.price_field != profile?.price.price_length &&  config().IccConfig.Configurators.price.frameProfilesAlt && profile?.type == 'frame') {
                                <span
                                  >
                                  {{dimensionUnit.unitSymbol != 'mm' ? '~' : ''}}
                                  @if (profile.price.list_price_length && profile.price.list_price_length !== profile.price.price_length && listPriceEnable && listPriceEnableInMarket) {
                                    <s
                                      >
                                      {{priceMarket(profile.price.list_price_length) | unitm:0:0:3 | currency: currency}}
                                    </s>
                                  }
                                  @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !profile.price.list_price_length) {
                                    <span>
                                      {{priceMarket(profile.price.price_length) | unitm:0:0:3 | currency: currency}}/
                                    </span>
                                  }
                                  @if (listPriceEnable && !listPriceEnableInMarket && profile.price.list_price_length) {
                                    <span>
                                      {{priceMarket(profile.price.list_price_length) | unitm:0:0:3 | currency: currency}}/
                                    </span>
                                  }
                                  <span [innerHTML]="2|formatUnit"></span>
                                  @if (profile?.price.price_field) {
                                    <span>
                                      {{ 'INTERFACE|lub' | translate }}&nbsp;
                                      @if (profile.price.list_price_field && profile.price.list_price_field !== profile.price.price_field && listPriceEnable && listPriceEnableInMarket) {
                                        <s
                                          >
                                          {{priceMarket(profile.price.list_price_field) | unitm:0:0:3 | currency: currency}}
                                        </s>
                                      }
                                      @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !profile.price.list_price_field) {
                                        <span>
                                          {{priceMarket(profile.price.price_field) | unitm:0:0:3 | currency: currency}}/
                                        </span>
                                      }
                                      @if (listPriceEnable && !listPriceEnableInMarket && profile.price.list_price_field) {
                                        <span>
                                          {{priceMarket(profile.price.list_price_field) | unitm:0:0:3 | currency: currency}}/
                                        </span>
                                      }
                                      <span [innerHTML]="2|formatUnit"></span>
                                    </span>
                                  }
                                  <br>
                                  </span>
                                }
                                @if (profile?.price.price_length && profile?.price.price_field == profile?.price.price_length &&  config().IccConfig.Configurators.price.frameProfilesAlt && profile?.type == 'frame') {
                                  <span
                                    >
                                    {{dimensionUnit.unitSymbol != 'mm' ? '~' : ''}}
                                    @if (profile.price.list_price_length && profile.price.list_price_length !== profile.price.price_length && listPriceEnable && listPriceEnableInMarket) {
                                      <s
                                        >
                                        {{priceMarket(profile.price.list_price_length) | unitm:0:0:3 | currency: currency}}
                                      </s>
                                    }
                                    @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !profile.price.list_price_length) {
                                      <span>
                                        {{priceMarket(profile.price.price_length) | unitm:0:0:3 | currency: currency}}/
                                      </span>
                                    }
                                    @if (listPriceEnable && !listPriceEnableInMarket && profile.price.list_price_length) {
                                      <span>
                                        {{priceMarket(profile.price.list_price_length) | unitm:0:0:3 | currency: currency}}/
                                      </span>
                                    }
                                    <span [innerHTML]="2|formatUnit"></span>
                                    <br>
                                    </span>
                                  }
                                  @if (profile?.price.price_piece) {
                                    <span>
                                      @if (profile.price.list_price_piece && profile.price.list_price_piece !== profile.price.price_piece && listPriceEnable && listPriceEnableInMarket) {
                                        <s
                                          >
                                          {{priceMarket(profile.price.list_price_piece) | currency: currency}}
                                        </s>
                                      }
                                      @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !profile.price.list_price_piece) {
                                        <span>
                                          {{priceMarket(profile.price.price_piece) | currency: currency}}/{{ 'UNIT|szt.' | translate
                                          }}<br>
                                        </span>
                                      }
                                      @if (listPriceEnable && !listPriceEnableInMarket && profile.price.list_price_piece) {
                                        <span>
                                          {{priceMarket(profile.price.list_price_piece) | currency: currency}}/{{ 'UNIT|szt.' | translate
                                          }}<br>
                                        </span>
                                      }
                                      <br>
                                      </span>
                                    }
                                    @if (profile?.price.price_construction) {
                                      <span>
                                        {{priceMarket(profile?.price.price_construction) | currency: currency}}/{{ 'WINDOW|konstrukcja' |
                                        translate }}
                                        @if (profile.price.list_price_construction && profile.price.list_price_construction !== profile.price.price_construction && listPriceEnable && listPriceEnableInMarket) {
                                          <s
                                            >
                                            {{priceMarket(profile.price.list_price_piece) | currency: currency}}
                                          </s>
                                        }
                                        @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !profile.price.list_price_construction) {
                                          <span>
                                            {{priceMarket(profile.price.price_construction) | currency: currency}}/{{ 'WINDOW|konstrukcja' |
                                            translate}}
                                          </span>
                                        }
                                        @if (listPriceEnable && !listPriceEnableInMarket && profile.price.list_price_construction) {
                                          <span>
                                            {{priceMarket(profile.price.list_price_construction) | currency: currency}}/{{
                                            'WINDOW|konstrukcja' | translate }}
                                          </span>
                                        }
                                        <br>
                                        </span>
                                      }
                                      @if (profile?.price.price_percent) {
                                        <span>
                                          {{profile?.price.price_percent}}%
                                          @if (profile.price.list_price_percent && profile.price.list_price_percent !== profile.price.price_percent && listPriceEnable && listPriceEnableInMarket) {
                                            <s
                                              >
                                              {{profile.price.list_price_percent | currency: currency}}
                                            </s>
                                          }
                                          @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !profile.price.list_price_percent) {
                                            <span>
                                              {{profile.price.price_percent | currency: currency}}%
                                            </span>
                                          }
                                          @if (listPriceEnable && !listPriceEnableInMarket && profile.price.list_price_percent) {
                                            <span>
                                              {{profile.price.list_price_percent | currency: currency}}%
                                            </span>
                                          }
                                        </span>
                                      }
                                    </span>
                                  }
                                </b>
                              </h4>
                            }

                            @if (!hiddenPrice && profile?.reinforcement?.price) {
                              <h4>{{ 'WINDOW|Cena wzmocnienia' | translate }}:
                                <b>
                                  <span>
                                    {{dimensionUnit.unitSymbol != 'mm' ? '~' : ''}}
                                    @if (priceMarket(profile?.reinforcement?.list_price) && priceMarket(profile?.reinforcement?.list_price) !== priceMarket(profile?.reinforcement?.price) && listPriceEnable && listPriceEnableInMarket) {
                                      <s
                                        >
                                        {{priceMarket(profile?.reinforcement?.list_price) | unitm:0:0:3 | currency: currency}}
                                      </s>
                                    }
                                    @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable) {
                                      <span>
                                        {{priceMarket(profile?.reinforcement?.price) | unitm:0:0:3 | currency: currency}}
                                      </span>
                                    }
                                    @if (listPriceEnable && !listPriceEnableInMarket) {
                                      <span>
                                        {{priceMarket(profile?.reinforcement?.list_price) | unitm:0:0:3 | currency: currency}}
                                      </span>
                                    }
                                  </span>
                                  /
                                  <span [innerHTML]="2|formatUnit"></span>
                                </b>
                              </h4>
                            }
                          </form>

                          @if (profile?.type === 'frame' && casings?.length > 0) {
                            <section class="casing">
                              <mat-checkbox [hidden]="profile?.onlyWithCasingCover" (change)="toggleCasing($event)"
                                value="isCasingAvailableForFrame" [checked]="isCasingOptionsSelected">{{ 'DOOR|Dodaj obejmę' |
                              translate }}</mat-checkbox>
                              @if (profile?.onlyWithCasingCover|| isCasingOptionsSelected && casingForm) {
                                <form [formGroup]="casingForm">
                                  <mat-form-field appearance="outline">
                                    <mat-label>{{ 'DOOR|Szerokość muru obejmy' | translate }} </mat-label>
                                    <input type="number" matInput formControlName="casingWallWidth" [value]="casingForm?.casingWallWidth" required iccNumberInput  [iccNumberInputInteger]="true">
                                    <mat-hint>{{ 'DOOR|Wartość powinna mieścić się w zakresie od {min} do {max} ze skokiem co {step}.' | translate: {min: lowestInnerCasingWidth + ' ' + dimensionUnit.unitSymbol, max: highestInnerCasingWidth + ' ' + dimensionUnit.unitSymbol, step: CASING_GAP + ' ' + dimensionUnit.unitSymbol} }}</mat-hint>
                                    @if (casingForm?.get('casingWallWidth').hasError('gapError')) {
                                      <mat-error>
                                        {{ 'DOOR|Wartość powinna mieścić się w zakresie od {min} do {max} ze skokiem co {step}.' | translate: {min: lowestInnerCasingWidth + ' ' + dimensionUnit.unitSymbol, max: highestInnerCasingWidth + ' ' + dimensionUnit.unitSymbol, step: CASING_GAP + ' ' + dimensionUnit.unitSymbol} }}
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                  <mat-form-field appearance="outline">
                                    <mat-label>{{ 'DOOR|Wyłożenie na mur' | translate }} [{{dimensionUnit.unitSymbol}}]</mat-label>
                                    <mat-select [disabled]="casingWallOverlap.length === 1" formControlName="casingWallOverlap"
                                      (selectionChange)="changeCasingBasedOnInnerWidthAndWallOverlap()">
                                      @for (overlap of casingWallOverlap; track overlap) {
                                        <mat-option [value]="overlap">
                                          {{overlap}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                </form>
                              }
                            </section>
                          }

                          @if (isPortalAvailable()) {
                            <section class="portal">
                              @if ((isPortalSelected === false || portalForm)) {
                                <mat-checkbox (change)="togglePortal($event)" [checked]="isPortalSelected || isDoorPortalFormOpen"
                                  >
                                  {{ 'DOOR|Dodaj portal' | translate }}
                                </mat-checkbox>
                              }
                              @if (isPortalSelected || isDoorPortalFormOpen) {
                                <form [formGroup]="portalForm">
                                  <div [class.wysiwygEditorContentInfo]="!isWysiwygEditorContentEmpty">
                                    <mat-form-field appearance="outline" style="width: 100%;">
                                      <mat-label>{{ 'DOOR|Szerokość muru portalu' | translate }} </mat-label>
                                      <input type="number" matInput formControlName="wallThickness" [value]="portalForm?.wallThickness" required iccNumberInput [iccNumberInputInteger]="true"/>
                                      <mat-hint>
                                        {{ 'DOOR|Wartość powinna mieścić się w zakresie od {min} do {max} ze skokiem co {step}.' | translate: {min: portalMinimumWallThickness + ' ' + dimensionUnit.unitSymbol, max: portalMaximumWallThickness + ' ' + dimensionUnit.unitSymbol, step: portalGap + ' ' + dimensionUnit.unitSymbol} }}
                                      </mat-hint>
                                      @if (portalForm?.get('wallThickness').hasError('gapError')) {
                                        <mat-error>
                                          {{ 'DOOR|Wartość powinna mieścić się w zakresie od {min} do {max} ze skokiem co {step}.' | translate: {min: portalMinimumWallThickness + ' ' + dimensionUnit.unitSymbol, max: portalMaximumWallThickness + ' ' + dimensionUnit.unitSymbol, step: portalGap + ' ' + dimensionUnit.unitSymbol} }}
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                  </div>
                                  <div [class.wysiwygEditorContentInfo]="!isWysiwygEditorContentEmpty">
                                    <mat-form-field appearance="outline" style="width: 100%;">
                                      <mat-label>{{ 'DOOR|Typ płyty' | translate }}</mat-label>
                                      <mat-select [disabled]="portalPlateTypes.length === 1" formControlName="plateType">
                                        @for (type of portalPlateTypes; track type) {
                                          <mat-option [value]="type">
                                            {{type}}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                  <div [class.wysiwygEditorContentInfo]="!isWysiwygEditorContentEmpty">
                                    <mat-form-field appearance="outline" style="width: 100%;">
                                      <mat-label>{{ 'DOOR|Szerokość lewego portalu' | translate }}
                                      [{{dimensionUnit.unitSymbol}}]</mat-label>
                                      <mat-select [disabled]="leftSideWidths.length === 1" formControlName="leftWidth">
                                        @for (size of leftSideWidths; track size) {
                                          <mat-option [value]="size">
                                            {{size}}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                  <div [class.wysiwygEditorContentInfo]="!isWysiwygEditorContentEmpty">
                                    <mat-form-field appearance="outline" style="width: 100%;">
                                      <mat-label>{{ 'DOOR|Szerokość prawego portalu' | translate }}
                                      [{{dimensionUnit.unitSymbol}}]</mat-label>
                                      <mat-select [disabled]="rightSideWidths.length === 1" formControlName="rightWidth">
                                        @for (size of rightSideWidths; track size) {
                                          <mat-option [value]="size">
                                            {{size}}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                  <div [class.wysiwygEditorContentInfo]="!isWysiwygEditorContentEmpty">
                                    <mat-form-field appearance="outline" style="width: 100%;">
                                      <mat-label>{{ 'DOOR|Wysokość górnego portalu' | translate }}
                                      [{{dimensionUnit.unitSymbol}}]</mat-label>
                                      <mat-select [disabled]="upperHeights.length === 1" formControlName="upperHeight">
                                        @for (size of upperHeights; track size) {
                                          <mat-option [value]="size">
                                            {{size}}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                </form>
                              }
                            </section>
                          }

                        </mat-card-content>
                        <mat-card-actions>
        <button [disabled]="
        (!casingForm?.valid && isCasingOptionsSelected) ||
        (profile?.onlyWithCasingCover && !casingForm?.valid) ||
        (!portalForm?.valid && this.availablePortals?.length > 0) ||
        (profile?.notStandardLength && profile.isDefaultLength === false && invalidLength)
        " mat-raised-button color="primary" (click)="add()">{{ 'INTERFACE|Dodaj' | translate }}
                          </button>
                        </mat-card-actions>
                      </mat-card>
